var $a0e402cef5d3566b$exports = {};
$a0e402cef5d3566b$exports = {
    "valid": `Der\u{12B}gs`
};


export {$a0e402cef5d3566b$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
